import { Component } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { LocalStorageService } from '@services/local-storage-service';
import { BroadcastService } from '@services/broadcast-service';
import { EventLoggerService } from '@services/event-logger-service';
import { ActivatedRoute, Router } from '@angular/router';
import { TimeService } from '@services/time-service';
import { AppConfig } from '../../app.config';
import { ReAcquisitionService } from '@services/re-acquisition-service/re-acquisition.service';

@Component({
  selector: 'acquisition-take-photo',
  templateUrl: './re-acquisition-take-photo.html',
  standalone: false,
})

export class ReAcquisitionTakePhotoComponent {
  currentUser: any;
  selectedConcern: 'face' | 'hair' = 'face';
  instantCheckup: Array<any>;
  isRebranding: boolean = false;
  photoTypes: string[] = [];
  constructor(
    private readonly conn: ConnectionService,
    private readonly broadcast: BroadcastService,
    private readonly eventLogger: EventLoggerService,
    private readonly timeService: TimeService,
    public appConfig: AppConfig,
    private readonly localStorageService: LocalStorageService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly reAcquisitionService: ReAcquisitionService,
  ) {
  }
  async ngOnInit(): Promise<void> {
    this.currentUser = this.conn.getActingUser();
    this.isRebranding = this.route.snapshot.queryParams?.isRebranding?.toLowerCase() === 'true';
    if (this.isRebranding) {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_upload_photo' }));
      this.selectedConcern = this.route.snapshot.queryParams.selectedConcern.toLowerCase() || 'face';
      this.photoTypes = this.getRequiredPhotosType(this.selectedConcern);
    }
    const type = Object.keys(this.appConfig.Shared.InstantCheckup.Type).filter((type_: string): boolean => {
      return ![this.appConfig.Shared.InstantCheckup.Type.INVALID,
        this.appConfig.Shared.InstantCheckup.Type.REPORT,
        this.appConfig.Shared.InstantCheckup.Type.BODY,
        this.appConfig.Shared.InstantCheckup.Type.OTHER].includes(type_);
    });

    this.instantCheckup = await this.conn.fetchInstantCheckup({
      userId: this.currentUser.id,
      limit: 1,
      type,
      dateRange: { startDate: this.timeService.removeDays(new Date(), 7), endDate: new Date() },
    });

    if (this.instantCheckup?.length === 0) {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 're-acquisition-take-photo' }));
      return;
    }

    if (this.isRebranding) return;
    const userQuery = this.localStorageService.getValue('userQuery');
    await this.conn.createPendingCall({ 
      type: this.appConfig.Shared.PendingCall.Type.RE_ACQUISITION_CALL, 
      message: userQuery 
    });
    this.router.navigate(['/re-acquisition/waiting-for-call']);
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  submit(): void {
    if (!this.instantCheckup?.length) {
      this.broadcast.broadcast('NOTIFY', { message: 'No photos found' });
      return;
    }
    this.conn.navigateToURL('/re-acquisition/waiting-for-call');
  }

  openInstantCheckup(tag: string, fromReacquisition?: boolean): void {
    const redirectUrl = this.router.url;
    if (!this.isRebranding) {
      this.localStorageService.setValue('CureSkin/redirectUrl', redirectUrl);
    }
    if (tag === this.appConfig.Shared.InstantCheckup.Type.SIDE_FACE && !fromReacquisition) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reacquisition_take_side_photo' }));
    }
    this.router.navigate(['user/instantCheckup/preview'], { queryParams: { tag, fromReacquisition } });
  }

  getRequiredPhotosType(selectedConcern: string): string[] {
    if(selectedConcern === this.appConfig.Shared.InstantCheckup.Type.FACE.toLowerCase()) {
      return [this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE, this.appConfig.Shared.InstantCheckup.Type.SIDE_FACE];
    } else {
      return [this.appConfig.Shared.InstantCheckup.Type.HAIR_FRONT, this.appConfig.Shared.InstantCheckup.Type.HAIR_TOP];
    }
  }

  onRebrandedSubmit(tag: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reacquisition_take_photo' }));
    if (!this.instantCheckup?.length) {
      this.openInstantCheckup(tag, true);
      return;
    }
    const isPendingCallCreated = this.reAcquisitionService.getIsPendingCallCreated();
    if (isPendingCallCreated) {
      this.router.navigate(['/re-acquisition/waiting-for-call'], { queryParams: { isRebranding: true } });
    } else {
      this.router.navigate(['/re-acquisition/user-query-v2']);
    }
  }
}
